export default ({ x }) => x.toLocaleString()
